var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/20*20/black/printer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "stripe",
    fill: "#fff",
    x: 12,
    y: 6,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5h10a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5H5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5z",
    id: "bg",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5V15a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4.5h-5z",
    id: "Rectangle",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    stroke: "#fff",
    x: 6.5,
    y: 10.5,
    width: 7,
    height: 1,
    rx: 0.5
  })))));
};
export default SvgPrinter;